import authService from "./auth.service";
import userService from "./user.service";
import relicService from "./relic.service";
import userRelicService from "./userRelic.service";
import galleryService from "./gallery.service";
import galleryRelicService from "./galleryRelic.service";

export default {
  // auth
  login(params) {
    return authService.login(params);
  },

  findMyInfoByToken(){
    return authService.findMyInfoByToken();
  },

  // user
  regUser(params) {
    return userService.regUser(params);
  },
  userFindAll(params) {
    return userService.userFindAll(params);
  },
  // relics
  relicFindAll(params) {
    return relicService.relicFindAll(params);
  },
  relicFindOne(id, params) {
    return relicService.relicFindOne(id, params);
  },
  // userRelics
  regUserRelics(params) {
    return userRelicService.regUserRelics(params);
  },
  userRelicFindAll(params) {
    return userRelicService.userRelicFindAll(params);
  },

  // gallery
  galleryFindAll(params){
    return galleryService.galleryFindAll(params);
  },

  galleryFindOne(id, params){
    return galleryService.galleryFindOne(id, params)
  },

  galleryFindOneByUserId(params){
    return galleryService.galleryFindOneByUserId(params)
  },

  regGallery(params){
    return galleryService.regGallery(params);
  },


  // galleryRelic
  galleryRelicFindAll(params){
    return galleryRelicService.galleryRelicFindAll(params)
  },

  galleryRelicFindByGalleryId(params){
    return galleryRelicService.galleryRelicFindByGalleryId(params)
  },
  regGalleryRelic(params){
    return galleryRelicService.regGalleryRelic(params)
  },
  deleteGalleryRelic(id){
    return galleryRelicService.deleteGalleryRelic(id)
  }
};
